import { render, staticRenderFns } from "./addVisible.vue?vue&type=template&id=faed81d2"
import script from "./addVisible.vue?vue&type=script&lang=js"
export * from "./addVisible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faed81d2')) {
      api.createRecord('faed81d2', component.options)
    } else {
      api.reload('faed81d2', component.options)
    }
    module.hot.accept("./addVisible.vue?vue&type=template&id=faed81d2", function () {
      api.rerender('faed81d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/goodsVisible/addVisible.vue"
export default component.exports